module.exports = __webpack_public_path__ + "img/optics.883c25c1.png";